"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwToggleButtonGroup = _interopRequireDefault(require("../cwtogglebuttongroup/CwToggleButtonGroup"));

var CwToggleButtonBool = function CwToggleButtonBool(props) {
  var leftButton = {
    id: props.invert,
    name: props.leftButtonText
  };
  var rightButton = {
    id: !props.invert,
    name: props.rightButtonText
  };
  var toggleButtons = [leftButton, rightButton];
  var selectedButton;

  if (props.invert) {
    selectedButton = props.value ? leftButton : rightButton;
  } else {
    selectedButton = props.value ? rightButton : leftButton;
  }

  var handleOnChange = function handleOnChange(item) {
    if (!props.onChange) {
      return;
    }

    props.onChange(item.id);
  };

  return _react.default.createElement(_CwToggleButtonGroup.default, {
    cwId: props.cwId,
    toggleButtons: toggleButtons,
    value: selectedButton,
    onChange: handleOnChange,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    tabIndex: props.tabIndex
  });
};

CwToggleButtonBool.propTypes = {
  /**
  * Connectwise element id to be used as unique identifier
  */
  cwId: _propTypes.default.string,

  /**
   * Used to control which toggle button is selected,
   * if true the right one is selected, false the left one is selected
   */
  value: _propTypes.default.bool,

  /**
   * Callback fired when one of the toggle buttons is clicked
   */
  onChange: _propTypes.default.func,

  /**
  * Callback fired when one of the toggle buttons is clicked
  */
  onFocus: _propTypes.default.func,

  /**
  * Callback fired when one of the toggle buttons is clicked
  */
  onBlur: _propTypes.default.func,

  /**
   * Text for the left toggle button
   */
  leftButtonText: _propTypes.default.string,

  /**
   * Text for the right toggle button
   */
  rightButtonText: _propTypes.default.string,

  /**
   * Used to control tab order
   */
  tabIndex: _propTypes.default.number,

  /**
   * Unused, added to satisfy pod element check
   */
  invalid: _propTypes.default.bool,

  /**
   * Default invert is false; meaning left button is false and right button is true
   * If invert is true, left button is true and right button is false
   */
  invert: _propTypes.default.bool
};
CwToggleButtonBool.defaultProps = {
  tabIndex: 0,
  invert: false
};
var _default = CwToggleButtonBool;
exports.default = _default;